const INCOTERMS = [
    { group: 1, value: 'EXW', text: 'EXW: Ex Works' },
    { group: 1, value: 'FCA', text: 'FCA: Free Carrier' },
    { group: 1, value: 'CPT', text: 'CPT: Carriage Paid To' },
    { group: 1, value: 'CIP', text: 'CIP: Carriage and Insurance Paid To' },
    { group: 1, value: 'DAP', text: 'DAP: Delivered at Place' },
    { group: 1, value: 'DPU', text: 'DPU: Delivered at Place Unloaded' },
    { group: 1, value: 'DDP', text: 'DDP: Delivered Duty Paid' },
    { group: 2, value: 'FAS', text: 'FAS: Free Alongside Ship' },
    { group: 2, value: 'FOB', text: 'FOB: Free on Board' },
    { group: 2, value: 'CFR', text: 'CFR: Cost and Freight' },
    { group: 2, value: 'CIF', text: 'CIF: Cost, Insurance, and Freight' },
];

// The incoterm code in `value` ("fob", " FOB ") when it is one of ours, otherwise null. The AI
// wizard sometimes answers with a product type ("FCL") where the email names no incoterm.
export function validIncoterm(value) {
    const code = String(value || '').trim().toUpperCase();
    return INCOTERMS.some(i => i.value === code) ? code : null;
}

export default INCOTERMS;
